import {
  mdiFacebook,
  mdiGmail,
  mdiLink,
  mdiWhatsapp,
} from "@mdi/js";
import Icon from "@mdi/react";
import CustomButton from './CustomButton';
import { useToast } from "@chakra-ui/toast";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const rawDomain = import.meta.env.VITE_FRONT_DOMAIN || '';
const frontDomain = rawDomain.endsWith('/') ? rawDomain : rawDomain + '/';

const InviteFriend = ({ code }) => {
  const toast = useToast();
  const { t } = useTranslation();

  if (!code) return null;

  const url = frontDomain + 'register/' + code
  const encodedUrl = encodeURIComponent(t('referral.inviteMessage', { link: url }));

  return (
    <div className="p-4">
      <div className="mx-auto">
        <div className="p-4 mx-auto space-y-4">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#187672] leading-tight">
            {t('referral.title')}
          </h2>
          <p className="mt-3 text-gray-600 text-base lg:text-lg">
            {t('referral.subtitle')}{' '}
            <span className="text-[#D9A520] font-semibold">
              {t('referral.subtitleHighlight')}
            </span>
          </p>
        </div>

        <div className="bg-green-primary border-2 border-dashed border-green-secondary flex justify-around items-center py-4 mt-4">
          <p className="text-blue-primary text-xl">{code}</p>
          <CustomButton
            className="flex py-2.5 rounded-full border px-4 border-blue-primary"
            icon={<Icon path={mdiLink} size={1} />}
            text={t('inviteFriend.copyLink')}
            onClick={() => {
              if (window.navigator.clipboard && window.navigator.clipboard.writeText) {
                window.navigator.clipboard.writeText(url);
                toast({
                  title: t('referral.copySuccess'),
                  description: t('referral.copySuccessDescription'),
                  status: 'success',
                  duration: 2000,
                  isClosable: true,
                  position: 'top-right',
                });
              }
            }}
          />
        </div>
      </div>
        <div className="flex space-x-2 justify-center mx-auto mt-8">
          <CustomButton
            className="flex border px-6 rounded-full border-primary"
            icon={<Icon path={mdiFacebook} size={1} />}
            text="Facebook"
            onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, '_blank')}
          />
          <CustomButton
            className="flex border px-6 rounded-full border-primary"
            icon={<Icon path={mdiWhatsapp} size={1} />}
            text="Whatsapp"
            onClick={() => window.open(`https://api.whatsapp.com/send?text=${encodedUrl}`, '_blank')}
          />
          <CustomButton
            className="flex border px-6 rounded-full border-primary"
            icon={<Icon path={mdiGmail} size={1} />}
            text="Email"
            onClick={() => (window.location = `mailto:?subject=Invitaci%C3%B3n&body=${encodedUrl}`)}
          />
        </div>
    </div>
  );
}

InviteFriend.propTypes = {
  code: PropTypes.string
}

export default InviteFriend
